import { motion } from 'framer-motion';
import styled from 'styled-components';
import { theme } from '@frameio/vapor';

const transition = {
  transition: { duration: 0.2, ease: theme.transitions.curves.primary },
};

export const crossFade = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  ...transition,
};

export const crossFadeWithDelay = {
  ...crossFade,
  animate: { ...crossFade.animate, transition: { delay: 0.2 } },
};

export const CrossFadeContainer = styled(motion.div)`
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

export const CrossFadeWithDelay = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <CrossFadeContainer {...crossFadeWithDelay}>{children}</CrossFadeContainer>
);
